import store from '../../store/store';
import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster();

export default (to , from , next) => {
    if(store.getters['authenticated'] && store.getters['roles'] === 'sales_account'){
        // if (from.path != "/commercial-screen/") {
            next();
        // }
        console.log("commercial-screen")
    }else{
        toaster.error(`You don't have permission to view sales account data`, {position: 'top'});
        next({name: from.name});
    }
}